import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p443666955913744384',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
